<template>
  <span v-bind="$attrs" @click="$emit('click')">
     <template v-if="mm<1 && repeat">
      重新发送
    </template>
    <template v-else-if="mm<1">
      发送验证码
    </template>
    <template v-else>
      重新发送(<em>{{mm}}</em>)
      <!--<slot name="pre">重新发送(</slot>-->
      <!--<em>{{mm}}</em>-->
      <!--<slot name="suf">)</slot>-->
    </template>
  </span>
</template>
<script>
export default {
  props: {
    autoStart: {
      type: Boolean,
      default: true,
      require: false
    },
    time: {
      type: Number,
      default: 0,
      require: true
    }
  },
  data: () => {
    return {
      mm: 0,
      repeat: false
    }
  },
  watch: {
    time: function () {
      this.mm = this.time
      this.autoStart && this.start()
    }
  },
  methods: {
    start () {
      this.repeat = true
      this.timer && clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.mm--
        if (+this.mm === 0){
          clearInterval(this.timer)
          this.finish()
        }
      }, 1000)
    },
    pause () {
      clearInterval(this.timer)
    },
    reset () {
      clearInterval(this.timer)
      this.mm = 0
    },
    finish () {
      this.$emit('finish')
    }
  },
  beforeDestroy () {
    this.timer && clearInterval(this.timer)
  }
}
</script>
